import { AverageConsumption } from '../../../../types/AverageConsumption';
import { Iso8601DateTimeString } from '../../../../types/Iso8601DateTimeString';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

interface AverageConsumptionMessage {
    averageConsumptions: AverageConsumption[];
}

export interface GetAverageConsumptionsParams {
    vesselId: string;
    dateFrom: Iso8601DateTimeString;
    dateTo: Iso8601DateTimeString;
    resolution: number;
}

export const getAverageConsumption = async ({
    vesselId,
    dateFrom,
    dateTo,
    resolution,
}: GetAverageConsumptionsParams): Promise<AverageConsumptionMessage> => {
    const response = await authorizedAxiosInstance.get(`/v1/consumptions/${vesselId}`, {
        params: {
            dateFrom,
            dateTo,
            resolution,
        },
    });
    return response.data;
};
